import {BlockInteractor} from '../../ui/structure/StructurePresenter';
import {BehaviorSubject} from 'rxjs';
import {Block} from '../../models/Block';
import {v4} from 'uuid';
import {Part} from '../../models/Part';
import {BlocksRepository} from './BlocksRepository';

export class DefaultBlockInteractor implements BlockInteractor, BlocksRepository {
    public blocks = new BehaviorSubject<Block[]>(this.initialBlocks);

    constructor(private initialBlocks: Block[]) {}

    public add() {
        this.blocks.next([
            ...this.blocks.value,
            {
                __uuid: v4(),
                repeats: 1,
                parts: [],
            },
        ]);
    }

    public trash(blockToBeTrashed: Block) {
        this.blocks.next(this.blocks.value.filter((block) => block.__uuid !== blockToBeTrashed.__uuid));
    }

    public addPart(blockForNewPart: Block, part: Part) {
        this.blocks.next([
            ...this.blocks.value.map((block) => {
                if (blockForNewPart.__uuid === block.__uuid) {
                    block.parts = [...block.parts, part];
                }
                return block;
            }),
        ]);
    }

    public trashPart(partToBeTrashed: Part) {
        this.blocks.next([
            ...this.blocks.value.map((block) => {
                return {
                    ...block,
                    parts: [...block.parts.filter((part) => part.__uuid !== partToBeTrashed.__uuid)],
                };
            }),
        ]);
    }

    public change(updatedBlock: Block) {
        this.blocks.next([
            ...this.blocks.value.map((block) => {
                return block.__uuid === updatedBlock.__uuid ? updatedBlock : block;
            }),
        ]);
    }
}
